(function () {
  function init() {
    var trigger = document.getElementById('target_loox-referral');
    if (!trigger) return;

    var SELECTOR = '.loox-referrals-entry-form';
    var btn = trigger.querySelector('button');

    function reveal(form) {
      trigger.removeAttribute('hidden');
      if (btn) {
        btn.addEventListener('click', function () {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    var existing = document.querySelector(SELECTOR);
    if (existing) { reveal(existing); return; }

    var observer = new MutationObserver(function () {
      var form = document.querySelector(SELECTOR);
      if (form) {
        observer.disconnect();
        reveal(form);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();